import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {getFirestore} from '@firebase/firestore'


const firebaseConfig = {
  apiKey: "AIzaSyCzYCMXyMatR2tCImoz7iSScvPmJ_XdI-o",
  authDomain: "harunluk-blog-app.firebaseapp.com",
  projectId: "harunluk-blog-app",
  storageBucket: "harunluk-blog-app.appspot.com",
  messagingSenderId: "210504499879",
  appId: "1:210504499879:web:bb3419cac6973247dfd182",
  measurementId: "G-SXHQ118L7H"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage();